export type AuthStatus = 'idle' | 'loading' | 'authenticated' | 'error';

export interface AuthState {
  token: string | null;
  expiresAt: number | null;
  userId: string | null;
  displayName: string | null;
  email: string | null;
  status: AuthStatus;
  error: string | null;
}

export const initialAuthState: AuthState = {
  token: null,
  expiresAt: null,
  userId: null,
  displayName: null,
  email: null,
  status: 'idle',
  error: null,
};
